import { FEATURE_ROUTES } from "@musicfy/components/Navigation/constants";
import { type TModelCategory } from "@musicfy/components/RVCInference/types";

export const getVoicePickerUrl = (
  modelsCategory?: TModelCategory,
  openTakeover = true
): string => {
  const params = new URLSearchParams();

  if (openTakeover) {
    params.set("open_takeover", "true");
  }

  if (modelsCategory) {
    params.set("models_category", modelsCategory);
  }

  const query = params.toString();

  return query ? `${FEATURE_ROUTES.voice}?${query}` : FEATURE_ROUTES.voice;
};
